import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

const availableSliderControllers = [];

export default class extends Controller {
    connect() {
        availableSliderControllers.push(this);

        const self = this;
        const element = self.element;
        const additionalConfig = element.dataset.splideConfig ? JSON.parse(element.dataset.splideConfig) : {};

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            omitEnd: true,
            pagination: false,
            type: 'loop',
            speed: 1000,
            autoplay: true,
            ...additionalConfig,
        };

        if ( KKS.splideI18n ) {
            config.i18n = KKS.splideI18n;
        }

        self.splide = new Splide(element, config);

        if (element.dataset.gallery === "true") {

            const thumbnailsConfig = {
                lazyLoad: 'nearby',
                autoWidth: true,
                focus: 'center',
                speed: 1000,
                autoplay: false,
                gap: '10px',
                pagination: false,
                arrows: true,
                isNavigation: true,
                rewind: true,
            };

            if ( KKS.splideI18n ) {
                thumbnailsConfig.i18n = KKS.splideI18n;
            }

            self.thumbSplide = new Splide(element.querySelector(".thumbnails"), thumbnailsConfig);
            self.splide.sync( self.thumbSplide );
            self.splide.mount();
            self.thumbSplide.mount();
        } else {
            self.splide.mount();
            this.slideCount();
        }
    }

    slideCount() {
        const element = this.element;
        const slider = this.splide;
        const total = slider.Components.Controller.getEnd() + 1;
        const sliderCount = element.querySelector(".slider-count");
        if (sliderCount) {
            slider.on('move', function (n) {
                sliderCount.innerHTML = `${n + 1}/${total}`;
            });
            sliderCount.innerHTML = `1/${total}`;
        }
    }

    thumbnails(index) {
        const self = this;
        self.thumbSplide.go(index);
        self.thumbSplide.on('click', function (activeSlide) {
            self.splide.go(activeSlide.index);
        });
    }

    static refreshSliders() {
        for (const controller of availableSliderControllers) {
            controller.splide.destroy();
            controller.splide.mount();
            controller.slideCount();
        }
    }
}
